module.exports = __webpack_public_path__ + "6d48cd405d7f332dc029235007fc1eb7.svg";